import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import {  firestore } from '../firebase';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { doc, setDoc, getDoc, arrayUnion, updateDoc, increment } from 'firebase/firestore';
import './ChatInterface.css';
import { Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import appConfig from '../config/appConfig.json'
import Feedback from './Feedback';
import UserDetailsInterface from './UserDetailsInterface';
import ReactGA from 'react-ga4';
import CountdownToMidnight from "./CountdownToMidnight";
import ContactTakingPopup from './ContactTakingPopup';
import { Timestamp } from 'firebase/firestore'; // for client SDK
// import { set } from 'react-datepicker/dist/date_utils';
import { useDebounce } from 'use-debounce';
import VoiceCallInterface from './VoiceCallInterface';

const sendSound = new Audio('/sounds/send-sound.mp3');
const receiveSound = new Audio('/sounds/receive-sound.mp3');

sendSound.volume = 0.4;   // 50% volume for send sound
receiveSound.volume = 0.3; // 70% volume for receive sound

const oneLiners = [
  "Guru aapke jeevan mein samriddhi aur gyaan laa sakta hai.",
  "Shani agar pratikool ho, toh delays aur struggles badh jaate hain.",
  "Chandra ki shanti se man ki shanti milti hai.",
  "Budh aapki soch aur communication mein tez banata hai.",
  "Mangal ka prabhav ho toh energy aur aggression dono badhte hain.",
  "Rahu illusion aur confusion create karta hai – sab kuch sach nahi hota!",
  "Ketu spiritual banata hai, lekin detachment bhi laata hai.",
  "Lagna yaani ascendant, aapki personality ka base hota hai.",
  "Dusra ghar dhan aur vaani ka hota hai – yeh paisa aur baat dono dikhata hai.",
  "Saptam bhaav (7th house) se shaadi aur partnerships dekhi jaati hain.",
  "Ashtam bhaav life ke secrets aur transformations dikhata hai.",
  "Pancham ghar se aapka creativity aur love life judge hota hai.",
  "Dasam ghar career aur public image batata hai.",
  "Chhatha ghar rogon aur dushmanon ka hota hai.",
  "Guru Mangal ki yuti ho toh insaan bahut passionate aur spiritual ho sakta hai.",
  "Surya aapki leadership aur ego dikhata hai.",
  "Chandra-Mangal ki yuti emotional decision making ko strong banati hai.",
  "Venus agar strong ho, toh luxury aur romance dono zindagi mein aate hain.",
  "Mangal 1st house mein ho toh person bold aur energetic hota hai.",
  "Shani 7th house mein ho toh shaadi late ya tough ho sakti hai.",
  "Rahu 10th house mein ho toh log aapko career ke liye yaad rakhte hain.",
  "Chandra 4th house mein emotional connection family se hota hai.",
  "Ketu agar lagna mein ho, toh vyakti thoda alag aur spiritual ho sakta hai.",
  "Sun-Mercury ka Budh-Aditya yog intelligence ke liye best mana jaata hai.",
  "Venus-Mars ki yuti strong attraction aur passion laati hai.",
  "Rahu agar 2nd house mein ho, toh relationships mein complications create karta hai.",
  "Ketu agar 3rd house mein ho, toh spiritual inclination ko strong banata hai.",
  "Surya agar 4th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Chandra agar 5th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Mangal agar 6th house mein ho, toh mental peace ko affect karta hai.",
  "Budh agar 7th house mein ho, toh insaan ko self-confident banata hai.",
  "Guru agar 8th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Shukra agar 9th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Shani agar 10th house mein ho, toh career mein growth ke chances deta hai.",
  "Rahu agar 11th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Ketu agar 12th house mein ho, toh relationships mein complications create karta hai.",
  "Surya agar 1st house mein ho, toh spiritual inclination ko strong banata hai.",
  "Chandra agar 2nd house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Mangal agar 3rd house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Budh agar 4th house mein ho, toh mental peace ko affect karta hai.",
  "Guru agar 5th house mein ho, toh insaan ko self-confident banata hai.",
  "Shukra agar 6th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Shani agar 7th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Rahu agar 8th house mein ho, toh career mein growth ke chances deta hai.",
  "Ketu agar 9th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Surya agar 10th house mein ho, toh relationships mein complications create karta hai.",
  "Chandra agar 11th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Mangal agar 12th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Budh agar 1st house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Guru agar 2nd house mein ho, toh mental peace ko affect karta hai.",
  "Shukra agar 3rd house mein ho, toh insaan ko self-confident banata hai.",
  "Shani agar 4th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Rahu agar 5th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Ketu agar 6th house mein ho, toh career mein growth ke chances deta hai.",
  "Surya agar 7th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Chandra agar 8th house mein ho, toh relationships mein complications create karta hai.",
  "Mangal agar 9th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Budh agar 10th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Guru agar 11th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Shukra agar 12th house mein ho, toh mental peace ko affect karta hai.",
  "Shani agar 1st house mein ho, toh insaan ko self-confident banata hai.",
  "Rahu agar 2nd house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Ketu agar 3rd house mein ho, toh vyakti mein creativity badhaata hai.",
  "Surya agar 4th house mein ho, toh career mein growth ke chances deta hai.",
  "Chandra agar 5th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Mangal agar 6th house mein ho, toh relationships mein complications create karta hai.",
  "Budh agar 7th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Guru agar 8th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Shukra agar 9th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Shani agar 10th house mein ho, toh mental peace ko affect karta hai.",
  "Rahu agar 11th house mein ho, toh insaan ko self-confident banata hai.",
  "Ketu agar 12th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Surya agar 1st house mein ho, toh vyakti mein creativity badhaata hai.",
  "Chandra agar 2nd house mein ho, toh career mein growth ke chances deta hai.",
  "Mangal agar 3rd house mein ho, toh emotional ups and downs laa sakta hai.",
  "Budh agar 4th house mein ho, toh relationships mein complications create karta hai.",
  "Guru agar 5th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Shukra agar 6th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Shani agar 7th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Rahu agar 8th house mein ho, toh mental peace ko affect karta hai.",
  "Ketu agar 9th house mein ho, toh insaan ko self-confident banata hai.",
  "Surya agar 10th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Chandra agar 11th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Mangal agar 12th house mein ho, toh career mein growth ke chances deta hai.",
  "Budh agar 1st house mein ho, toh emotional ups and downs laa sakta hai.",
  "Guru agar 2nd house mein ho, toh relationships mein complications create karta hai.",
  "Shukra agar 3rd house mein ho, toh spiritual inclination ko strong banata hai.",
  "Shani agar 4th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Rahu agar 5th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Ketu agar 6th house mein ho, toh mental peace ko affect karta hai.",
  "Surya agar 7th house mein ho, toh insaan ko self-confident banata hai.",
  "Chandra agar 8th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Mangal agar 9th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Budh agar 10th house mein ho, toh career mein growth ke chances deta hai.",
  "Guru agar 11th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Shukra agar 12th house mein ho, toh relationships mein complications create karta hai.",
  "Shani agar 1st house mein ho, toh spiritual inclination ko strong banata hai.",
  "Rahu agar 2nd house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Ketu agar 3rd house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Surya agar 4th house mein ho, toh mental peace ko affect karta hai.",
  "Chandra agar 5th house mein ho, toh insaan ko self-confident banata hai.",
  "Mangal agar 6th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Budh agar 7th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Guru agar 8th house mein ho, toh career mein growth ke chances deta hai.",
  "Shukra agar 9th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Shani agar 10th house mein ho, toh relationships mein complications create karta hai.",
  "Rahu agar 11th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Ketu agar 12th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Surya agar 1st house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Chandra agar 2nd house mein ho, toh mental peace ko affect karta hai.",
  "Mangal agar 3rd house mein ho, toh insaan ko self-confident banata hai.",
  "Budh agar 4th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Guru agar 5th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Shukra agar 6th house mein ho, toh career mein growth ke chances deta hai.",
  "Shani agar 7th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Rahu agar 8th house mein ho, toh relationships mein complications create karta hai.",
  "Ketu agar 9th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Surya agar 10th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Chandra agar 11th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Mangal agar 12th house mein ho, toh mental peace ko affect karta hai.",
  "Budh agar 1st house mein ho, toh insaan ko self-confident banata hai.",
  "Guru agar 2nd house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Shukra agar 3rd house mein ho, toh vyakti mein creativity badhaata hai.",
  "Shani agar 4th house mein ho, toh career mein growth ke chances deta hai.",
  "Rahu agar 5th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Ketu agar 6th house mein ho, toh relationships mein complications create karta hai.",
  "Surya agar 7th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Chandra agar 8th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Mangal agar 9th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Budh agar 10th house mein ho, toh mental peace ko affect karta hai.",
  "Guru agar 11th house mein ho, toh insaan ko self-confident banata hai.",
  "Shukra agar 12th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Shani agar 1st house mein ho, toh vyakti mein creativity badhaata hai.",
  "Rahu agar 2nd house mein ho, toh career mein growth ke chances deta hai.",
  "Ketu agar 3rd house mein ho, toh emotional ups and downs laa sakta hai.",
  "Surya agar 4th house mein ho, toh relationships mein complications create karta hai.",
  "Chandra agar 5th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Mangal agar 6th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Budh agar 7th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Guru agar 8th house mein ho, toh mental peace ko affect karta hai.",
  "Shukra agar 9th house mein ho, toh insaan ko self-confident banata hai.",
  "Shani agar 10th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Rahu agar 11th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Ketu agar 12th house mein ho, toh career mein growth ke chances deta hai.",
  "Surya agar 1st house mein ho, toh emotional ups and downs laa sakta hai.",
  "Chandra agar 2nd house mein ho, toh relationships mein complications create karta hai.",
  "Mangal agar 3rd house mein ho, toh spiritual inclination ko strong banata hai.",
  "Budh agar 4th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Guru agar 5th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Shukra agar 6th house mein ho, toh mental peace ko affect karta hai.",
  "Shani agar 7th house mein ho, toh insaan ko self-confident banata hai.",
  "Rahu agar 8th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Ketu agar 9th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Surya agar 10th house mein ho, toh career mein growth ke chances deta hai.",
  "Chandra agar 11th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Mangal agar 12th house mein ho, toh relationships mein complications create karta hai.",
  "Budh agar 1st house mein ho, toh spiritual inclination ko strong banata hai.",
  "Guru agar 2nd house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Shukra agar 3rd house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Shani agar 4th house mein ho, toh mental peace ko affect karta hai.",
  "Rahu agar 5th house mein ho, toh insaan ko self-confident banata hai.",
  "Ketu agar 6th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Surya agar 7th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Chandra agar 8th house mein ho, toh career mein growth ke chances deta hai.",
  "Mangal agar 9th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Budh agar 10th house mein ho, toh relationships mein complications create karta hai.",
  "Guru agar 11th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Shukra agar 12th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Shani agar 1st house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Rahu agar 2nd house mein ho, toh mental peace ko affect karta hai.",
  "Ketu agar 3rd house mein ho, toh insaan ko self-confident banata hai.",
  "Surya agar 4th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Chandra agar 5th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Mangal agar 6th house mein ho, toh career mein growth ke chances deta hai.",
  "Budh agar 7th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Guru agar 8th house mein ho, toh relationships mein complications create karta hai.",
  "Shukra agar 9th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Shani agar 10th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Rahu agar 11th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Ketu agar 12th house mein ho, toh mental peace ko affect karta hai.",
  "Surya agar 1st house mein ho, toh insaan ko self-confident banata hai.",
  "Chandra agar 2nd house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Mangal agar 3rd house mein ho, toh vyakti mein creativity badhaata hai.",
  "Budh agar 4th house mein ho, toh career mein growth ke chances deta hai.",
  "Guru agar 5th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Shukra agar 6th house mein ho, toh relationships mein complications create karta hai.",
  "Shani agar 7th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Rahu agar 8th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Ketu agar 9th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Surya agar 10th house mein ho, toh mental peace ko affect karta hai.",
  "Chandra agar 11th house mein ho, toh insaan ko self-confident banata hai.",
  "Mangal agar 12th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Budh agar 1st house mein ho, toh vyakti mein creativity badhaata hai.",
  "Guru agar 2nd house mein ho, toh career mein growth ke chances deta hai.",
  "Shukra agar 3rd house mein ho, toh emotional ups and downs laa sakta hai.",
  "Shani agar 4th house mein ho, toh relationships mein complications create karta hai.",
  "Rahu agar 5th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Ketu agar 6th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Surya agar 7th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Chandra agar 8th house mein ho, toh mental peace ko affect karta hai.",
  "Mangal agar 9th house mein ho, toh insaan ko self-confident banata hai.",
  "Budh agar 10th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Guru agar 11th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Shukra agar 12th house mein ho, toh career mein growth ke chances deta hai.",
  "Shani agar 1st house mein ho, toh emotional ups and downs laa sakta hai.",
  "Rahu agar 2nd house mein ho, toh relationships mein complications create karta hai.",
  "Ketu agar 3rd house mein ho, toh spiritual inclination ko strong banata hai.",
  "Surya agar 4th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Chandra agar 5th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Mangal agar 6th house mein ho, toh mental peace ko affect karta hai.",
  "Budh agar 7th house mein ho, toh insaan ko self-confident banata hai.",
  "Guru agar 8th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Shukra agar 9th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Shani agar 10th house mein ho, toh career mein growth ke chances deta hai.",
  "Rahu agar 11th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Ketu agar 12th house mein ho, toh relationships mein complications create karta hai.",
  "Surya agar 1st house mein ho, toh spiritual inclination ko strong banata hai.",
  "Chandra agar 2nd house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Mangal agar 3rd house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Budh agar 4th house mein ho, toh mental peace ko affect karta hai.",
  "Guru agar 5th house mein ho, toh insaan ko self-confident banata hai.",
  "Shukra agar 6th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Shani agar 7th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Rahu agar 8th house mein ho, toh career mein growth ke chances deta hai.",
  "Ketu agar 9th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Surya agar 10th house mein ho, toh relationships mein complications create karta hai.",
  "Chandra agar 11th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Mangal agar 12th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Budh agar 1st house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Guru agar 2nd house mein ho, toh mental peace ko affect karta hai.",
  "Shukra agar 3rd house mein ho, toh insaan ko self-confident banata hai.",
  "Shani agar 4th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Rahu agar 5th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Ketu agar 6th house mein ho, toh career mein growth ke chances deta hai.",
  "Surya agar 7th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Chandra agar 8th house mein ho, toh relationships mein complications create karta hai.",
  "Mangal agar 9th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Budh agar 10th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Guru agar 11th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Shukra agar 12th house mein ho, toh mental peace ko affect karta hai.",
  "Shani agar 1st house mein ho, toh insaan ko self-confident banata hai.",
  "Rahu agar 2nd house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Ketu agar 3rd house mein ho, toh vyakti mein creativity badhaata hai.",
  "Surya agar 4th house mein ho, toh career mein growth ke chances deta hai.",
  "Chandra agar 5th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Mangal agar 6th house mein ho, toh relationships mein complications create karta hai.",
  "Budh agar 7th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Guru agar 8th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Shukra agar 9th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Shani agar 10th house mein ho, toh mental peace ko affect karta hai.",
  "Rahu agar 11th house mein ho, toh insaan ko self-confident banata hai.",
  "Ketu agar 12th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Surya agar 1st house mein ho, toh vyakti mein creativity badhaata hai.",
  "Chandra agar 2nd house mein ho, toh career mein growth ke chances deta hai.",
  "Mangal agar 3rd house mein ho, toh emotional ups and downs laa sakta hai.",
  "Budh agar 4th house mein ho, toh relationships mein complications create karta hai.",
  "Guru agar 5th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Shukra agar 6th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Shani agar 7th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Rahu agar 8th house mein ho, toh mental peace ko affect karta hai.",
  "Ketu agar 9th house mein ho, toh insaan ko self-confident banata hai.",
  "Surya agar 10th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Chandra agar 11th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Mangal agar 12th house mein ho, toh career mein growth ke chances deta hai.",
  "Budh agar 1st house mein ho, toh emotional ups and downs laa sakta hai.",
  "Guru agar 2nd house mein ho, toh relationships mein complications create karta hai.",
  "Shukra agar 3rd house mein ho, toh spiritual inclination ko strong banata hai.",
  "Shani agar 4th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Rahu agar 5th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Ketu agar 6th house mein ho, toh mental peace ko affect karta hai.",
  "Surya agar 7th house mein ho, toh insaan ko self-confident banata hai.",
  "Chandra agar 8th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Mangal agar 9th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Budh agar 10th house mein ho, toh career mein growth ke chances deta hai.",
  "Guru agar 11th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Shukra agar 12th house mein ho, toh relationships mein complications create karta hai.",
  "Shani agar 1st house mein ho, toh spiritual inclination ko strong banata hai.",
  "Rahu agar 2nd house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Ketu agar 3rd house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Surya agar 4th house mein ho, toh mental peace ko affect karta hai.",
  "Chandra agar 5th house mein ho, toh insaan ko self-confident banata hai.",
  "Mangal agar 6th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Budh agar 7th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Guru agar 8th house mein ho, toh career mein growth ke chances deta hai.",
  "Shukra agar 9th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Shani agar 10th house mein ho, toh relationships mein complications create karta hai.",
  "Rahu agar 11th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Ketu agar 12th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Surya agar 1st house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Chandra agar 2nd house mein ho, toh mental peace ko affect karta hai.",
  "Mangal agar 3rd house mein ho, toh insaan ko self-confident banata hai.",
  "Budh agar 4th house mein ho, toh jeevan mein financial stability laa sakta hai.",
  "Guru agar 5th house mein ho, toh vyakti mein creativity badhaata hai.",
  "Shukra agar 6th house mein ho, toh career mein growth ke chances deta hai.",
  "Shani agar 7th house mein ho, toh emotional ups and downs laa sakta hai.",
  "Rahu agar 8th house mein ho, toh relationships mein complications create karta hai.",
  "Ketu agar 9th house mein ho, toh spiritual inclination ko strong banata hai.",
  "Surya agar 10th house mein ho, toh vyakti ko ziddi bana deta hai.",
  "Chandra agar 11th house mein ho, toh apne goal ke liye focused bana deta hai.",
  "Mangal agar 12th house mein ho, toh mental peace ko affect karta hai.",
];


const ChatInterface = () => {
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [partnerPlaceInput, setPartnerPlaceInput] = useState('');
  const [locationPredictions, setLocationPredictions] = useState([]);
  const [locationLoading, setLocationLoading] = useState(false);
  const [locationSelected, setLocationSelected] = useState(false);
  const [debouncedPlace] = useDebounce(partnerPlaceInput, 300);
  const [hasTypedPlace, setHasTypedPlace] = useState(false);
  const [loadingContinueChat, setLoadingContinueChat] = useState(false);
  const [hasFetchedAstrologyData, setHasFetchedAstrologyData] = useState(false);
  const [userData, setUserData] = useState(null);
  const [language, setLanguage] = useState('en');
  const [chatCount, setChatCount] = useState(0);
  const [totalChatCount, setTotalChatCount] = useState(0);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isPlanExpired, setIsPlanExpired] = useState(false);
  const [showOptions, setShowOptions] = useState(true);
  const [showLimitMessage, setShowLimitMessage] = useState(false);
  const [showContactMessage, setShowContactMessage] = useState(false);
  const [contactSkipped, setContactSkipped] = useState(false);
  // const [user] = useAuthState(auth);
  const [user, setUser] = useState(null);
  const [userId, setUserId] = useState(localStorage.getItem('userId'));
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalling, setIsInstalling] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const dailyFreeChats = 3;
  const newUserFreeChats = 10
  const [oneLiner, setOneLiner] = useState('');
  const [purchaseInitiated, setPurchaseInitiated] = useState(false);
  const [loadingVerifyPurchase, setLoadingVerifyPurchase] = useState(false);
  const [isVoiceCallOpen, setIsVoiceCallOpen] = useState(false);
  const [showPartnerChoicePopup, setShowPartnerChoicePopup] = useState(true);
  const [loveChatMode, setLoveChatMode] = useState(false);
  const [partnerDetails, setPartnerDetails] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [prefilledPartnerDetails, setPrefilledPartnerDetails] = useState({
    name: '',
    dob: '',
    time: '',
    place: ''
  });

  useEffect(() => {
    if (userId) {
      ReactGA.set({ user_id: userId }); // Sets globally
    }
  }, [userId]); 

  useEffect(() => {
    if (debouncedPlace && !locationSelected && hasTypedPlace) {
      fetchLocationPredictions(debouncedPlace);
    }
  }, [debouncedPlace, locationSelected, hasTypedPlace]);
  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const mode = params.get('mode');

    const name = localStorage.getItem('partnerName') || '';
    const dob = localStorage.getItem('partnerDob') || '';
    const time = localStorage.getItem('partnerTime') || '';
    const place = localStorage.getItem('partnerPlace') || '';

    setPrefilledPartnerDetails({ name, dob, time, place });
    if (place) {
      setPartnerPlaceInput(place);
    }

    if (mode === 'love') {
      setShowPartnerChoicePopup(true);  // show popup
      setLoveChatMode(true);
    } else {
      setShowPartnerChoicePopup(false); // skip popup
      setLoveChatMode(false);
    }

    const fetchUserData = async () => {
      if (!userId) {
        setUser(null); // No userId in localStorage
        return;
      }
      
      ReactGA.set({ user_id: userId });
      
      try {
        const userRef = doc(firestore, 'users', userId);
        const userDoc = await getDoc(userRef);
  
        if (!userDoc.exists()) {
          setUser(null); // No user found
          return;
        }
  
        let userDataFromDoc = userDoc.data();

        if (userDataFromDoc && userDataFromDoc.purchaseInitiated && userDataFromDoc.purchaseInitiated === true) {
          setPurchaseInitiated(true);
          // updateSubscriptionStatus();
        }

        if (userDataFromDoc && userDataFromDoc.language) {
          setLanguage(userDataFromDoc.language);
        } else {
          // Default to English if no language is set
          setLanguage('English');
        }

        const hasAnyDashaExpired = (dashaData) => {
          if (!dashaData || !dashaData.current_dasha) return true;
        
          const levels = [
            'major',
            'minor',
            'sub_minor',
            'sub_sub_minor',
            'sub_sub_sub_minor'
          ];
        
          const nowIST = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
        
          return levels.some(level => {
            const dasha = dashaData.current_dasha[level];
            if (!dasha || !dasha.end) return true;
        
            try {
              const [datePart, timePart] = dasha.end.trim().split(/\s+/);
              const [day, month, year] = datePart.split('-').map(Number);
              const [hour, minute] = timePart.split(':').map(Number);
        
              // Build UTC date from IST components, then shift to IST
              const dashaEndUTC = new Date(Date.UTC(year, month - 1, day, hour - 5, minute - 30));
              const dashaEndIST = new Date(dashaEndUTC.getTime() + 19800000); // 5.5 hours in ms
        
              return nowIST > dashaEndIST;
            } catch (e) {
              console.warn(`Failed to parse dasha end date for ${level}`, e);
              return true;
            }
          });
        };        
  
        // Check if dasha_data is missing or empty
        if (
          !userDataFromDoc.dasha_data ||
          Object.keys(userDataFromDoc.dasha_data).length === 0 ||
          hasAnyDashaExpired(userDataFromDoc.dasha_data)
        ) {

          console.log("dasha data expired or missing, fetching from backend...");
          try {
            const response = await axios.post(`${appConfig.REACT_APP_BACKEND_URL}/dasha/current-dasha`, userDataFromDoc);
        
            if (response.status === 200) {
              const dashaData = response.data;
        
              // Update Firestore
              await setDoc(userRef, { dasha_data: dashaData }, { merge: true });
        
              // Update local object
              userDataFromDoc = {
                ...userDataFromDoc,
                dasha_data: dashaData,
              };
            }
          } catch (err) {
            console.error("Error fetching dasha data:", err);
          }
        }
        console.log("Passed dasha check")
  
        setUser(userDataFromDoc); // Store full user object with (possibly updated) dasha_data
        setUserData(userDataFromDoc); // Optional: if you have a separate userData state
  
      } catch (error) {
        console.error("Error fetching user data:", error);
        setUser(null);
      }
    };
  
    fetchUserData();
  }, [userId]);
  
  
  //For showing the contact message popup after 5 chats 
  useEffect(() => {
    if (contactSkipped && 
      (chatCount === 5)) { // Show the contact message after 5 chats
      setShowContactMessage(true);
    }
  }, [contactSkipped, chatCount]);  

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * oneLiners.length);
    setOneLiner(oneLiners[randomIndex]);
  }, []);
  

  const chatWindowRef = useRef(null);
  const inputRef = useRef(null);
  const [isTyping, setIsTyping] = useState(false);
  const [sessionId, setSessionId] = useState(() => uuidv4());
  const [chatCountForFeedback, setChatCountForFeedback] = useState(0);
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [pendingMessage, setPendingMessage] = useState(''); // Store pending message
  const [canChat, setCanChat] = useState(true);
  const [pendingQuestionFromDetails, setPendingQuestionFromDetails] = useState(null);
  const [isQuestionProcessed, setIsQuestionProcessed] = useState(false);
  const [platform, setPlatform] = useState('Web');
  const [showInstallSection, setShowInstallSection] = useState(true);

  const playSendSound = () => {
    sendSound.play();
  };

  const playReceiveSound = () => {
    receiveSound.play();
  };
  
  const getPlatform = () => {
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
      return 'PWA';
    }
    return 'Website';
  };

  // Function to track a button click event
  const trackEvent = (category, action, label = '') => {
    // Function is depricated    
    // ReactGA.event({
    //   category,
    //   action: action + ' - ' + getPlatform(),
    //   label,
    //   platform: getPlatform(), // 🎯 new addition
    // });
  };

  const trackGA4Event = (eventName, params = {}) => {
    ReactGA.event(eventName, {
      platform: getPlatform(), // optional, if you want
      ...params,
    });
  };
  
  const processingRef = useRef(false);
  const questionProcessedRef = useRef(new Set());

  // Simulate typing animation and then send a message
  const simulateTypingAndSendMessage = (messageText, isGreeting = false) => {
    // setIsTyping(true);
    
    setTimeout(() => {
      setIsTyping(false);
      
      const timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      const newMessage = {
        text: messageText,
        sender: 'bot',
        time: timestamp,
      };

      setMessages((prevMessages) => [...prevMessages, newMessage]);
      // Reset typing state if it's not a greeting message
      if (!isGreeting) {
        setLoading(false);
      }
    }, 2000); // 2-second delay
  };

  // Function to send greeting message
  const sendGreetingMessage = (data) => {
    const greetingMessage = data;
    setIsTyping(true);
    simulateTypingAndSendMessage(greetingMessage, true);
  };

  const showToast = (message) => {
    toast.success(message, {
      position: "top-right",
      autoClose: 5000, // Time before it disappears (in ms)
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const initialOptions = partnerDetails
  ? ['Are we compatible?', 'Is this a good time to propose?', 'What does our future look like?', 'Will we get married?']
  : ['Tell me about my career.', 'When will I find true love?', 'When will I become rich?', 'When will I get married?'];
  // Handle when a user selects an option
  const handleOptionSelect = (option) => {
    setShowOptions(false); // Hide the options after selection
    // simulateTypingAndSendMessage("I’m analyzing your astrological chart to give your answer.");
    handleSendOption(option); // Send the selected option as a message
  };
  // Handle when a user selects an option
  const handleSendOption = async (option) => {
    setLoading(true);
    playSendSound();

    const timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    const userRef = doc(firestore, 'users', user.uid);
    const userDoc = await getDoc(userRef);
    if (userDoc.exists()) {
      setChatCount(userDoc.data().RemainingchatCount); // Store full user object
    }
    if (userDoc.data().RemainingchatCount <= 0 && !isSubscribed) {
        // If chat limit is reached, store the option as pending and show the subscription prompt
        setShowLimitMessage(true);
        trackGA4Event('payment_popup_viewed', {
          source: 'Chat',
          mode: loveChatMode ? 'love' : 'personal',
        });
        setMessages((prevMessages) => [
            ...prevMessages,
            { text: 'You have reached your free chat limit. Please subscribe to continue.', sender: 'bot', time: timestamp },
        ]);
        setPendingMessage(option); // Store the selected option as pending
        setLoading(false);
        return;
    }

    // Add the selected option to the chat history
    setMessages((prevMessages) => [
        ...prevMessages,
        { text: option, sender: 'user', time: timestamp },
    ]);

    // setChatCountForFeedback((prev) => prev + 1); // Increment chat count for feedback purposes

    // Show feedback popup if this is the 3rd chat
    // if (chatCountForFeedback === 3 && !showFeedbackPopup) {
    //     setShowFeedbackPopup(true);
    // }

    // Send the selected option to the API
    await sendMessageToAPI(option);

    // Decrement chat count and update Firestore only after response is received
    const updatedChatCount = userDoc.data().RemainingchatCount - 1;
    setChatCount(updatedChatCount);

    await setDoc(doc(firestore, 'users', user.uid), {
        ...userData,
        RemainingchatCount: updatedChatCount,
    }, { merge: true });

    // Increment chat count and update Firestore only after response is received
    await updateDoc(doc(firestore, 'users', user.uid), {
      totalChatCount: increment(1),
    }, { merge: true });
    

    setLoading(false);
  };

  useEffect(() => {
    // Check if feedback has already been submitted
    const hasSubmittedFeedback = localStorage.getItem('feedbackSubmitted');
    if (hasSubmittedFeedback) {
      setFeedbackSubmitted(true);
    }
  }, []);

  useEffect(() => {
    if (!user) return;

    /* ───── 0. Send greeting immediately (only once per mount) ───── */
    sendGreetingMessage(
      "Namaste! How can I assist you today with your astrological queries?"
    );                                               // ⭐

    let ignore = false;                              // avoids setState after unmount

    const fetchUserData = async () => {
      setIsLoading(true);

      try {
        /* ───────── 1. read Firestore doc ───────── */
        const userRef = doc(firestore, "users", user.uid);
        const snap    = await getDoc(userRef);
        if (!snap.exists()) throw new Error("User not found");
        const data    = snap.data();

        /* ───────── 2. plan status ───────── */
        const now      = new Date();
        const todayStr = now.toDateString();

        let planExpiryDate = null;
        if (data.planExpiry?.seconds !== undefined)
          planExpiryDate = new Date(data.planExpiry.seconds  * 1000);
        else if (data.planExpiry?._seconds !== undefined)
          planExpiryDate = new Date(data.planExpiry._seconds * 1000);

        const planIsActive    = !!planExpiryDate && planExpiryDate >  now;
        const planJustExpired = !!planExpiryDate && planExpiryDate <= now;

        /* push booleans into state once */
        if (!ignore) {
          setIsSubscribed(planIsActive);
          setIsPlanExpired(planJustExpired);
        }

        /* clear plan field if it just expired */
        if (planJustExpired) {
          await updateDoc(
            userRef,
            {
              prevPlanExpiry: planExpiryDate,
              planExpiry    : null,
              isSubscribed  : false
            },
            { merge: true }
          );
        }

        /* ───────── 3. free-quota logic (runs only when no active plan) ───────── */
        let remaining = data.RemainingchatCount ?? 0;

        const isPWA =
          window.matchMedia("(display-mode: standalone)").matches ||
          window.navigator.standalone ||
          document.referrer.includes("android-app://");

        const freeAllowance = isPWA ? 10 : dailyFreeChats;

        /* convert lastChatAt ⇒ JS Date */
        let lastChatDate = null;
        if (data.lastChatAt?.seconds !== undefined)
          lastChatDate = new Date(data.lastChatAt.seconds  * 1000);
        else if (data.lastChatAt?._seconds !== undefined)
          lastChatDate = new Date(data.lastChatAt._seconds * 1000);

        const isNewDay =
          !lastChatDate || lastChatDate.toDateString() !== todayStr;

        /* if on free tier and new day → reset */
        if (!planIsActive && isNewDay) {
          remaining = freeAllowance;
        }

        /* ───────── 4. ALWAYS stamp lastChatAt = now ───────── */
        await updateDoc(
          userRef,
          {
            RemainingchatCount: remaining,
            lastChatAt        : Timestamp.fromDate(now), // ⭐ always updated
            usedPwaToday      : isPWA,
          },
          { merge: true }
        );

        /* ───────── 5. push to local state ───────── */
        if (!ignore) {
          setChatCount(remaining);
          setUserData({ ...data, RemainingchatCount: remaining });
        }
      } catch (err) {
        console.error("fetchUserData:", err);
      } finally {
        if (!ignore) setIsLoading(false);
      }
    };

    fetchUserData();

    return () => {
      ignore = true;                   // cleanup flag
    };
  }, [user]);

  useEffect(() => {
    // Trigger feedback popup after three chats
    if (chatCountForFeedback === 3) {
      setShowFeedbackPopup(true);
    }
  }, [chatCountForFeedback]);

  useEffect(() => {
    if (
      userData &&
      (
        !userData.astro_data ||
        !userData.astro_data.planetary_positions ||
        userData.astro_data.planetary_positions.length === 0 ||
        !userData.dasha_data ||
        !userData.dasha_data.current_dasha
      )
    ) {
      fetchAstrologyDetails(userData);
      setHasFetchedAstrologyData(true);
    }
  }, [userData, hasFetchedAstrologyData]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus(); // Focus the input field when the component mounts
    }
  }, []);

  useEffect(() => {
    if(user) {
      // On page load or refresh, set a new session ID
      const newSessionId = uuidv4();
      setSessionId(newSessionId);
      
      // Optionally, reset conversation summary on page refresh
      resetConversationSummary(newSessionId);
    }
  }, [user]);

  useEffect(() => {
    // Logic to handle reset and new session ID when the page is refreshed
    window.addEventListener('beforeunload', () => {
      const newSessionId = uuidv4();
      setSessionId(newSessionId);
      resetConversationSummary(newSessionId);
    });
    
    return () => {
      window.removeEventListener('beforeunload', () => {});
    };
  }, []);

  useEffect(() => {
  // Guard against multiple executions
  if (!pendingQuestionFromDetails || isLoading || messages.length === 0) return;
  
  // Check if this specific question has already been processed
  if (questionProcessedRef.current.has(pendingQuestionFromDetails)) return;
  
  // Check if we're currently processing
  if (processingRef.current) return;
  
  // Set processing flag
  processingRef.current = true;
  
  const processQuestion = async () => {
    try {
      const timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      
      // Add message only if it hasn't been added yet
      setMessages((prevMessages) => {
        // Check if message already exists
        const messageExists = prevMessages.some(
          msg => msg.text === pendingQuestionFromDetails && msg.sender === 'user'
        );
        
        playSendSound();
        if (messageExists) return prevMessages;
        
        return [
          ...prevMessages,
          { text: pendingQuestionFromDetails, sender: 'user', time: timestamp }
        ];
      });
      setShowOptions(false);
      // Process the pending question
      await sendMessageToAPI(pendingQuestionFromDetails);
      
      // Update chat count
      const updatedChatCount = chatCount - 1;
      setChatCount(updatedChatCount);
      // setChatCountForFeedback(prev => prev + 1);
      const today = Timestamp.fromDate(new Date());
      // Update Firestore
      await setDoc(doc(firestore, 'users', user.uid), {
        ...userData,
        RemainingchatCount: updatedChatCount,
        lastChatAt: today,
        pendingQuestion: null
      }, { merge: true });

      const totalChatCount = chatCount + 1;
      setTotalChatCount(totalChatCount);

      await setDoc(doc(firestore, 'users', user.uid), {
          ...userData,
          totalChatCount: totalChatCount,
      }, { merge: true });

      // Mark this specific question as processed
      questionProcessedRef.current.add(pendingQuestionFromDetails);
      
      // Clear pending question from state
      setPendingQuestionFromDetails(null);
    } catch (error) {
      console.error('Error processing pending question:', error);
    } finally {
      // Reset processing flag
      processingRef.current = false;
    }
  };

  // Use setTimeout to ensure greeting message is shown first
  const timer = setTimeout(processQuestion, 1000);

  return () => {
    clearTimeout(timer);
  };
  }, [pendingQuestionFromDetails, isLoading, messages.length]);
  
  useEffect(() => {
    return () => {
      questionProcessedRef.current.clear();
    };
  }, []);

  useEffect(() => {
        const detectPlatform = () => {
          const isPWA = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
          return isPWA ? 'PWA' : 'Web';
        };
        setPlatform(detectPlatform());
  }, []);
  
  // useEffect(() => {
  //   if (pendingQuestionFromDetails) {
  //     setIsQuestionProcessed(false);
  //   }
  // }, [pendingQuestionFromDetails]);
  
  //Function to save summary in db
  
  const saveConversationSummary = async (userMessage, summary) => {
    try {
      const userRef = doc(firestore, 'users', user.uid);
      const userDoc = await getDoc(userRef);
      let histories = ((userDoc.exists() && userDoc.data().conversationHistory) || []).slice(-50);
        histories.push({
        sessionId: sessionId,  // Save with session ID
            userMessage: userMessage,
            summary: summary,
            timestamp: new Date(),
      })
      localStorage.setItem('summary', summary)
        await updateDoc(userRef, {
        conversationHistory: histories,
        // Append summary to existing conversationSummary
        conversationSummary: arrayUnion(summary) // Append summaries
      });
    } catch (error) {
      console.error("Error saving conversation summary:", error);
    }
  };

  //Function to generate the summary
  const summarizeResponse = async (userInput, llmResponse) => {
    try {
      const response = await axios.post(`${appConfig.REACT_APP_BACKEND_URL}/chat/get-summary`, { userInput, llmResponse });
      return response.data.summary;
    } catch (error) {
      console.error("Error fetching summary:", error);
      return null;
    }
  };

  const resetConversationSummary = async (newSessionId, summary) => {
    try {
      // console.log("from reset function", summary)
      const userRef = doc(firestore, 'users', user.uid);
      await updateDoc(userRef, {
        conversationSummary: [],
        currentSessionId: newSessionId  // Store the new session ID in Firestore
      }, { merge: true });
    } catch (error) {
      console.error("Error resetting conversation summary:", error);
    }
  };
  
  // Check if there's related context in the conversation history
  const checkForRelatedContext = async (userInput) => {
    const userRef = doc(firestore, 'users', user.uid);
    const userDoc = await getDoc(userRef);
    
    if (userDoc.exists()) {
      const summaries = (userDoc.data().conversationSummary || []).slice(-3);
      // Concatenate summaries to create ongoing context
      const concatenatedSummaries = summaries.join(' '); // Use all past summaries

      if (concatenatedSummaries) {
        return concatenatedSummaries; // Return all past summaries as context
      }
    }
    return null; // No context found
  };

  const fetchPartnerDetails = async (partnerData) => {
    try {
      // Send user data to the backend for astrology API calls and Firestore update
      const response = await axios.post(`${appConfig.REACT_APP_BACKEND_URL}/api/astrology-details`, partnerData);
  
      if (response.status === 200) {
        const astroData = response.data;
  
        // Update the frontend state with the received astroData
        let dashaData = null;
        const dashaResponse = await axios.post(`${appConfig.REACT_APP_BACKEND_URL}/dasha/current-dasha`, userData);
        if (dashaResponse.status === 200) {
          dashaData = dashaResponse.data;
        }
        localStorage.setItem('partnerAstroData', JSON.stringify(astroData));
        localStorage.setItem('partnerDashaData', JSON.stringify(dashaData));
      }
    } catch (error) {
      console.error("Error fetching astrology details:", error);
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: 'Error fetching astrology details. Please try again.', sender: 'bot' },
      ]);
    }
  }

  const fetchAstrologyDetails = async (userData) => {
    try {
      // Send user data to the backend for astrology API calls and Firestore update
      const response = await axios.post(`${appConfig.REACT_APP_BACKEND_URL}/api/astrology-details`, userData);
  
      if (response.status === 200) {
        const astroData = response.data;
  
        // Update the frontend state with the received astroData
        let dashaData = null;
        const dashaResponse = await axios.post(`${appConfig.REACT_APP_BACKEND_URL}/dasha/current-dasha`, userData);
        if (dashaResponse.status === 200) {
          dashaData = dashaResponse.data;
        }
        setUserData((prevUserData) => ({
          ...prevUserData,
          astro_data: astroData,
          dasha_data: dashaData,
        }));
      }
    } catch (error) {
      console.error("Error fetching astrology details:", error);
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: 'Error fetching astrology details. Please try again.', sender: 'bot' },
      ]);
    }
  };

  const handleSend = async (message = '', voiceResponse = false) => {
    if (message!="" && !message === '') {
      setInput(message) // Use the provided userMessage if available
    }
    if (input.trim() === '' && message=="") return;

    const timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    const userMessage = input.trim() || message.trim();
    // Hide options as soon as a message is sent
    setShowOptions(false); // Ensure options are hidden when sending a message
    setMessages((prevMessages) => [
        ...prevMessages,
        { text: userMessage, sender: 'user', time: timestamp },
    ]);
    setInput(''); // Clear the input field
    playSendSound();

    const userRef = doc(firestore, 'users', user.uid);
    const userDoc = await getDoc(userRef);
    if (userDoc.exists()) {
      setChatCount(userDoc.data().RemainingchatCount); // Store full user object     
    }
    // Check if the plan is expired or chat limit reached
    if ((userDoc.data().RemainingchatCount <= 0 && !isSubscribed)) {
        setIsVoiceCallOpen(false); // Close voice call popup if open
        setShowLimitMessage(true); // Show the popup to buy a plan
        trackGA4Event('payment_popup_viewed', {
          source: 'Chat',
          mode: loveChatMode ? 'love' : 'personal'
        });
        setPendingMessage(userMessage); // Store the message for later if they buy a plan
        return; // Don't send message to LLM yet
    }

    // Normal message sending logic if they have chats remaining
    setIsTyping(true);
    await new Promise(resolve => setTimeout(resolve, 2000));

    const response = await sendMessageToAPI(userMessage, voiceResponse); 
    
    const updatedChatCount = userDoc.data().RemainingchatCount - 1;
    const updatedTotalChatCOunt = userDoc.data().totalChatCount + 1;
    // setChatCountForFeedback(prev => prev + 1); // Increment chat count for feedback
    setChatCount(updatedChatCount);
    setTotalChatCount(updatedTotalChatCOunt);

    // if (chatCountForFeedback === 3 && !showFeedbackPopup) {
    //   setShowFeedbackPopup(true);
    // }
    const today = Timestamp.fromDate(new Date());
    await setDoc(doc(firestore, 'users', user.uid), {
        ...userData,
        RemainingchatCount: updatedChatCount,
        lastChatAt: today
    }, { merge: true });
    await updateDoc(doc(firestore, 'users', user.uid), {
      totalChatCount: increment(1),
    }, { merge: true });
    
    trackEvent(`Chat`, `New message sent`, 'Send');
    setIsTyping(false);
    return response; // Return the response for further processing if needed
  };

  const sendMessageToAPI = async (userMessage, voiceResponse = false) => {
      setLoading(true);
      setIsTyping(true);
      console.log(userMessage)
      console.log("Sending message to API with userData:", userData);
      const summary = localStorage.getItem('summary') || "";
      const relatedContext = summary
      try {
        // Check if userData and astroData are valid
        if (userData && userData.astro_data) {
          let partnerAstroData = localStorage.getItem('partnerAstroData');
          let partnerDashaData = localStorage.getItem('partnerDashaData');
          console.log('userData Found')
          const requestPayload = {
            userMessage,
            userData,
            relatedContext,
          };

          if (voiceResponse) {
            requestPayload.voiceResponse = true; // Indicate that this is a voice response
            trackGA4Event('voice_message_sent', {
              source: 'Chat',
              mode: loveChatMode ? 'love' : 'personal',
              message_length: userMessage.length,
            });
          }
          console.log('Sending request payload:', requestPayload);
          // Conditionally add partner data only if required
          if (userData?.astro_data && loveChatMode && partnerAstroData && partnerDashaData) {
            requestPayload.partnerAstroData = JSON.parse(partnerAstroData);
            requestPayload.partnerDashaData = JSON.parse(partnerDashaData);
          }

          // ✅ TRACK GA4 EVENT HERE
          trackGA4Event('new_message_sent', {
            source: 'Chat',
            mode: loveChatMode ? 'love' : 'personal',
            message_length: userMessage.length
          });

          console.log('sending request')
          const response = await axios.post(
            `${appConfig.REACT_APP_BACKEND_URL}/chat/get-response`,
            requestPayload
          );
          const llmResponse = response.data.response;

          setMessages((prevMessages) => [
              ...prevMessages,
              { text: llmResponse, sender: 'bot' },
          ]);
          playReceiveSound();

          userMessage = "Previous Summary: " + summary + ", New User Message: " + userMessage;
          // Save conversation summary if needed
          const new_summary = await summarizeResponse(userMessage, llmResponse);
          if (new_summary) {
              await saveConversationSummary(userMessage, new_summary);
            }
            return response.data;
          } else {
            // Refresh the page while retaining context
            console.warn('Invalid userData or missing astroData. Refreshing page.');
            localStorage.setItem('userMessage', userMessage); // Save context if needed
            window.location.reload();
          }

      } catch (error) {
        console.error('Error sending message to API:', error);
          setMessages((prevMessages) => [
              ...prevMessages,
              { text: 'Error fetching response. Please try again.', sender: 'bot' },
          ]);
          // playReceiveSound();
      } finally {
          setIsTyping(false);
          setLoading(false);
      }
  };

  const getCookieValue = (name) => {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(`${name}=`)) {
        return cookie.substring(name.length + 1);
      }
    }
    return null;
  };

  const handlePlanPurchase = async (planType, planId, duration, chats) => {
      try {
          trackEvent(`Chat`, `Plan Purchase Initiated`, planType);
          trackGA4Event('plan_purchase_intiated', {
            source: 'Chat',
            mode: loveChatMode ? 'love' : 'personal',
            plan: planType
          });
          setLoadingContinueChat(true); // Show loading state for the purchase process
          await updateDoc(doc(firestore, 'users', user.uid), {
            purchaseInitiated: true,
            planDurationRequested: duration,
            planChatsRequested: chats,
            planTypeRequested: planType
          }, { merge: true });
          const fbc = getCookieValue('_fbc') || null; // Get _fbc value from cookies
          const fbp = getCookieValue('_fbp') || null; // Get _fbp value from cookies

          const { data } = await axios.post(`${appConfig.REACT_APP_BACKEND_URL}/plan/purchase`, {
              planType,
              amount: planId,
              duration,
              chats,
              userId: user.uid,
          });

          const options = {
              amount: planId * 100,
              order_id: data.orderId,
              handler: async (response) => {
                  try {
                      await axios.post(`${appConfig.REACT_APP_BACKEND_URL}/plan/confirm`, {
                          userId: user.uid,
                          razorpay_payment_id: response.razorpay_payment_id,
                          planType,
                          duration,
                          chats,
                          fbc, // Include fbc in the backend payload
                          fbp // Include fbp in the backend payload
                      });



                      // Update local chat count to purchased chats (e.g., 10)
                      setChatCount(chats);
                      await updateChatCountInFirestore(chats); // Update Firestore with the new chat count

                      setShowLimitMessage(false); // Close the pop-up
                      setCanChat(true); // Allow the user to chat again

                      // If there was a pending message, send it to the LLM
                      if (pendingMessage) {
                        await sendMessageToAPI(pendingMessage); // Send the pending message to the LLM
                        setPendingMessage(''); // Clear the pending message

                        // Decrement the chat count after sending the response
                        const updatedChatCount = chats - 1; // Assuming they got chats after purchasing
                        setChatCount(updatedChatCount);
                        await updateChatCountInFirestore(updatedChatCount); // Update Firestore with the new chat count
                    }

                  } catch (error) {
                      alert('Plan purchase failed. Please try again.');
                  }
              },
          };
          setLoadingContinueChat(false); // Hide loading state after initiating purchase
          const paymentObject = new window.Razorpay(options);
          paymentObject.open();
      } catch (error) {
          alert('Purchase initiation failed.');
      }
  };

  const fetchLocationPredictions = async (input) => {
    setLocationLoading(true);
    try {
      const response = await axios.get(`${appConfig.REACT_APP_BACKEND_URL}/geocode/autocomplete`, {
        params: { text: input }
      });
      setLocationPredictions(response.data || []);
    } catch (error) {
      console.error('Error fetching location predictions:', error);
    } finally {
      setLocationLoading(false);
    }
  };
  
  const updateChatCountInFirestore = async (updatedChatCount) => {
    const today = Timestamp.fromDate(new Date());
      await setDoc(doc(firestore, 'users', user.uid), {
          ...userData,
          RemainingchatCount: updatedChatCount,
          lastChatAt: today
      }, { merge: true });
  };

  const closeLimitMessage = () => {
    setShowLimitMessage(false);
    if (pendingMessage) {
      const timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: 'You need to buy a plan to continue chatting.', sender: 'bot', time: timestamp },
      ]);
      setPendingMessage(''); // Clear the pending message after prompting
      setInput(""); // Hide the limit message
    }
  };

  const scrollToBottom = () => {
    if (chatWindowRef.current) {
      chatWindowRef.current.scroll({
        top: chatWindowRef.current.scrollHeight,
        behavior: 'smooth'
      });
    }
  };

  const updateSubscriptionStatus = async () => {

    setLoadingVerifyPurchase(true);
    if (!user || !user.uid) return;
    try {
      const userRef = doc(firestore, 'users', user.uid);
      const userDoc = await getDoc(userRef);
      if (!userDoc.exists()) return;
      const userData = userDoc.data();
      const planType = userData.planTypeRequested || 'Daily';
      const duration = userData.planDurationRequested || 1;
      const chats = userData.planChatsRequested || 9999;

      const { data } = await axios.post(`${appConfig.REACT_APP_BACKEND_URL}/payments/verify-purchase`, {
        planType,
        duration,
        chats,
        userId: user.uid,
      });
      if (data && data.message) {
        showToast(data.message);
      }
      setLoadingVerifyPurchase(false);
    } catch (error) {
      setLoadingVerifyPurchase(false);
      console.error('Error verifying subscription:', error);
      showToast('Something went wrong while verifying your plan.');
    }
  };

  const redirectToLifeReport = () => {
    trackEvent(`Chat`, `Life Report Clicked`, 'Annoucement Bar');
    trackGA4Event('life_report_clicked', {
      source: 'Chat',
      mode: loveChatMode ? 'love' : 'personal'
    });
    document.getElementById('announcementBar').style.display = 'none';
    window.location.href = '/report/life-report/payment-page';
  };

  const redirectToMiniReports = () => {
    trackGA4Event('mini_reports_clicked', {
      source: 'Chat',
      mode: loveChatMode ? 'love' : 'personal'
    });
    document.getElementById('announcementBar').style.display = 'none';
    window.location.href = '/mini-reports';
  };

  const handleClosingContact = () => {
    setShowContactMessage(false); // Hides the popup when closed
  };
  
  const handleSubmitContact = (contact) => {
    console.log("User Contact:", contact);
    userData.contact = contact;
    setUserData(userData);
    saveUserContact(userId,userData);
    trackEvent(`User Profile`, `Email Updated (Pop-Up)`, " Email Updated - pop-up");
    trackGA4Event('email updated', {
      source: 'Chat',
      mode: loveChatMode ? 'love' : 'personal',
    });
  };



  const saveUserContact = async (userId, userData) => {
    console.log("Saving User Data:", userData);

    try {
      console.log("Formatted user data:", userData);

      // Create reference to the user document
      const userRef = doc(firestore, "users", userId);

      // Ensure `contactSkipped` is set to false after saving the contact
      await setDoc(
        userRef,
        {
          ...userData, // Merge with existing user data
          
        },
        { merge: true }
      );

      console.log("User contact saved and contactSkipped set to false!");
    } catch (error) {
      console.error("Error saving user data:", error);
    }
  };

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // setShowBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  

  // Enhanced PWA detection with immediate feedback
  useEffect(() => {
    // Check for iOS devices
    setIsIOS(/iPad|iPhone|iPod/.test(navigator.userAgent) || 
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

    // Immediate PWA check
    const isRunningAsPWA = () => {
      return window.matchMedia('(display-mode: standalone)').matches || 
              window.navigator.standalone || 
              document.referrer.includes('android-app://');
    };

    // Initial check
    if (!isRunningAsPWA()) {
      setShowInstallSection(true);
    }

    const beforeInstallHandler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallSection(true);
      localStorage.removeItem('installDismissed');
    };

    const installedHandler = () => {
      setShowInstallSection(false);
      localStorage.setItem('installDismissed', 'true');
    };

    window.addEventListener('beforeinstallprompt', beforeInstallHandler);
    window.addEventListener('appinstalled', installedHandler);

    return () => {
      window.removeEventListener('beforeinstallprompt', beforeInstallHandler);
      window.removeEventListener('appinstalled', installedHandler);
    };
  }, []);

  const hasAnyDashaExpired = (dashaData) => {
    if (!dashaData || !dashaData.current_dasha) return true;
  
    const levels = [
      'major',
      'minor',
      'sub_minor',
      'sub_sub_minor',
      'sub_sub_sub_minor'
    ];
  
    const nowIST = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
  
    return levels.some(level => {
      const dasha = dashaData.current_dasha[level];
      if (!dasha || !dasha.end) return true;
  
      try {
        const [datePart, timePart] = dasha.end.trim().split(/\s+/);
        const [day, month, year] = datePart.split('-').map(Number);
        const [hour, minute] = timePart.split(':').map(Number);
  
        // Build UTC date from IST components, then shift to IST
        const dashaEndUTC = new Date(Date.UTC(year, month - 1, day, hour - 5, minute - 30));
        const dashaEndIST = new Date(dashaEndUTC.getTime() + 19800000); // 5.5 hours in ms
  
        return nowIST > dashaEndIST;
      } catch (e) {
        console.warn(`Failed to parse dasha end date for ${level}`, e);
        return true;
      }
    });
  }; 

  const storePartnerDetails = (details) => {
    trackEvent(`Chat`, `Partner Details Added`, 'Marriage Chat');
    trackGA4Event('partner details added', {
      source: 'Chat',
      mode: loveChatMode ? 'love' : 'personal',
    });
    if (!details) {
      console.warn("No partner details found");
      return;
    }
  
    // Retrieve existing details from localStorage
    const existingDetails = {
      name: localStorage.getItem('partnerName') || '',
      dob: localStorage.getItem('partnerDob') || '',
      time: localStorage.getItem('partnerTime') || '',
      place: localStorage.getItem('partnerPlace') || '',
    };
  
    // Check if any detail has changed
    const hasChanged = Object.keys(existingDetails).some(
      (key) => String(existingDetails[key]) !== String(details[key])
    );
  
    // Save updated values
    localStorage.setItem('partnerName', details.name);
    localStorage.setItem('partnerDob', details.dob);
    localStorage.setItem('partnerTime', details.time);
    localStorage.setItem('partnerPlace', details.place);

    const partnerDashaData = localStorage.getItem('partnerDashaData');
  
    if (hasChanged || hasAnyDashaExpired(JSON.parse(partnerDashaData))) {
      console.log("Partner details changed, fetching new astrology data...");
      localStorage.setItem('partnerLat', details.lat);
      localStorage.setItem('partnerLon', details.lon);
      fetchPartnerDetails(details);
    }
  };
      
  const handleInstall = async () => {
    setIsInstalling(true);
    
    try {
      if (deferredPrompt) {
        deferredPrompt.prompt();
        const choice = await deferredPrompt.userChoice;
        
        if (choice.outcome === 'accepted') {
          trackEvent(`Install Clicked - Popup`, `Install Clicked (Install pop-up)`, 'App side menu');
          console.log('User installed the app');
        } else {
          console.log('User dismissed the install prompt');
        }
        setDeferredPrompt(null);
      } else if (isIOS) {
        // iOS specific instructions
        alert(`To install:
1. Tap the Share icon 
2. Select "Add to Home Screen"
3. Tap "Add" in the top right`);
      } else {
        // Android/Desktop fallback
        alert('Look for "Install" or "Add to Home Screen" in your browser menu');
      }
    } catch (error) {
      console.error('Installation error:', error);
      trackEvent('Install Error', error.message, 'Home Page');
    } finally {
      setIsInstalling(false);
    }
  };


  if (!user) {
    return (
      <UserDetailsInterface />
    );
  }
  if (isLoading) {
    return (
      <div className='loadin-page'>
        {/* Top Section */}
        <div className="top-section">
            <div className="top-section-content">
              <Link to="/" className='no-underline'><i class="ri-arrow-left-line"></i></Link>
              <div className="profile-pic-container">
                <img src="astro.png" alt="Astrologer" className="profile-pic" />
                <div className="status-dot"></div>  {/* Green online status dot */}
              </div>
              <div className="astrologer-info">
                <h4>Acharya Raghavendra</h4>
                <h5>Remaining Chats: {chatCount}</h5>
              </div>
            </div>
          </div>
        <div className="loading-page-container">
          <h3 class="loading-text">{oneLiner}</h3>
          {/* <p>{oneLiner}</p> */}
          <div className="blur-balls"></div>
          <video className='loading-video' src='https://cdnl.iconscout.com/lottie/premium/thumb/magic-circle-animated-icon-download-in-lottie-json-gif-static-svg-file-formats--occult-magical-sun-mystic-sign-astrology-pack-entertainment-icons-8542368.mp4' autoPlay loop muted></video>
        </div>
      </div>
      
    );
  }
  return (
    <div>
      <div className="chat-container">
        {/* Top Section */}
        <div className="top-section">
          <div className="top-section-content">
            <Link to="/" className='no-underline'><i class="ri-arrow-left-line"></i></Link>
            <div className="profile-pic-container">
              <img src="astro.png" alt="Astrologer" className="profile-pic" />
              <div className="status-dot"></div>  {/* Green online status dot */}
            </div>
            <div className="astrologer-info">
              <h4>Acharya Raghavendra</h4>
              <h5>Remaining Chats: {chatCount}</h5>
            </div>
          </div>
        </div>
        <div className="announcement-bar" id="announcementBar" onClick={redirectToMiniReports}>
          <span>Click to unlock your life secrets with <b>personalized mini reports</b>.</span>
        </div>
        {/* Chat Window */}
        <div className="chat-window" ref={chatWindowRef}>
          {Array.isArray(messages) && messages.map((msg, index) => (
            <div key={index} className={`message ${msg.sender}`}>
              <div className="message-content">
                {msg.sender === 'bot' ? (
                  <ReactMarkdown>{msg.text}</ReactMarkdown>
                ) : (
                  msg.text
                )}
                {/* Render the timestamp for both user and bot */}
                <div className="timestamp">{msg.time}</div>
              </div>
            </div>
          ))}

          {/* Loading indicator */}
          {isTyping && (  
            <div className="typing-indicator">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          )}

          {showPartnerChoicePopup && (
            <div className="popup-overlay">
              <div className="popup-card">
                <h2>Enter your partner's details:</h2>
                <form onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.target;
                  const details = {
                    name: form.name.value,
                    dob: form.dob.value,
                    time: form.time.value,
                    place: partnerPlaceInput,
                    lat: selectedLocation?.lat,
                    lon: selectedLocation?.lon,
                  };
                  setPartnerDetails(details);
                  setShowPartnerChoicePopup(false);
                  storePartnerDetails(details);
                }}>
                  <label>Partner's Name:</label>
                  <input name="name" defaultValue={prefilledPartnerDetails.name} required />

                  <label>Date of Birth:</label>
                  <input name="dob" defaultValue={prefilledPartnerDetails.dob} type="date" required />

                  <label>Time of Birth:</label>
                  <input name="time" defaultValue={prefilledPartnerDetails.time} type="time" required />

                  <label>Place of Birth:</label>
                  <input
                    type="text"
                    name="place"
                    defaultValue={prefilledPartnerDetails.place}
                    value={partnerPlaceInput}
                    onChange={(e) => {
                      setPartnerPlaceInput(e.target.value);
                      setLocationSelected(false);
                      setSelectedLocation(null); // clear selection
                      setHasTypedPlace(true); // mark that user typed
                    }}
                    placeholder="Enter place of birth"
                    required
                  />

                  {!locationSelected && (locationLoading || locationPredictions.length > 0) && (
                    <ul className="predictions" style={{ position: 'relative', zIndex: 1000 }}>
                      {locationLoading ? (
                        <li>Finding location...</li>
                      ) : (
                        locationPredictions.map((prediction) => (
                          <li
                            key={prediction.place_id}
                            onClick={() => {
                              setPartnerPlaceInput(prediction.name);
                              setLocationSelected(true);
                              setSelectedLocation({
                                lat: prediction.lat,
                                lon: prediction.lon,
                              });
                              setLocationPredictions([]);
                            }}
                          >
                            {prediction.name}
                          </li>
                        ))
                      )}
                    </ul>
                  )}

                  <button type="submit" className="start-love-chat">Start Love Chat</button>
                </form>
                <hr />
                <button
                  onClick={() => {
                    setShowPartnerChoicePopup(false);
                    setLoveChatMode(false);
                  }}
                  className="personal-chat-button"
                >
                  Continue Personal Chat
                </button>
              </div>
            </div>
          )}


          {purchaseInitiated && (
            <div className="update-purchase-status">
              <button onClick={() => updateSubscriptionStatus()}>
                {loadingVerifyPurchase ? <span className="spinner"> <div className="spin-dot"></div></span> : 'Click here to update chat count!'}
                </button>
            </div>
          )}

          {/* <button onClick={() => setIsVoiceCallOpen(true)} className="voice-call-cta">
            📞
          </button> */}

          {/* Display options if showOptions is true */}
          {showOptions && (
            <div className="options-container">
              {initialOptions.map((option, index) => (
                <button key={index} className="option-button" onClick={() => handleOptionSelect(option)}>
                  {option}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Input Section */}
        <div className="input-container">
          <input
            ref={inputRef}
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Ask your question here..."
            onKeyPress={(e) => e.key === 'Enter' && handleSend()}
            // disabled={loading}
          />
          <button onClick={handleSend} disabled={loading}><i className="ri-send-plane-fill"></i></button>
        </div>

        {/* Subscription Modal */}
        {showLimitMessage && (
          <div className="subscription-popup">
          <div className="subscription-content">
            <span className="close-btn" onClick={closeLimitMessage}>&times;</span>
            
            <h1 className="subscription-heading">
              <i className="ri-bard-fill"></i> 
              Stay Connected with the Stars
              <i className="ri-bard-fill"></i>
            </h1>
            
            <h2 className="subscription-message">
              You have exhausted the free chats for today
            </h2>
            {/* <p><span>Loading free chats in:</span>
            <CountdownToMidnight />
            </p> */}
              {/* <p><span>Limited time offer. Ends in:</span>
              <CountdownToMidnight targetDate="2025-05-08T22:00:00"/>
              </p> */}
            {true ? (
              <div>
                  <h2>Get <strong className='highlighted-text'>unlimited</strong> 
                  </h2>
                  {/* <h2> starting at just <strong className='highlighted-text'>₹0.15 </strong> per chat </h2> */}
                    {/* <span className='strikethrough'> (₹499)</span> */}
                    {/* <img src='https://cdni.iconscout.com/illustration/premium/thumb/pandit-ji-reading-mantras-illustration-download-in-svg-png-gif-file-formats--male-indian-mantra-slok-pack-people-illustrations-2319299.png?f=webp' alt='pandit'></img> */}
                
                    <div class="pricing-wrapper">
                      <div class="plan-card">
                        <h2 class="plan-title">Daily Plan</h2>
                        <p class="price">₹21 <span class="only">only</span></p>
                        <ul class="feature-list">
                          <li>✅ 10 free chats</li>
                          <li>✅ Valid for 24 hours</li>
                          <li>✅ 24/7 realtime chat</li>
                        </ul>
                        <button 
                          onClick={() => handlePlanPurchase('Daily', '21', 1, 10)}
                          className="popup-button">
                          {loadingContinueChat ? <span className="spinner"> <div className="spin-dot"></div></span> : 'Purchase Plan'}</button>
                      </div>
                  
                      <div class="plan-card">
                        <h2 class="plan-title">Weekly Plan</h2>
                        <p class="price">₹51 <span class="only">only</span></p>
                        <ul class="feature-list">
                          <li>✅ 100 free chats</li>
                          {/* <li>✅ Limited voice chat</li> */}
                          <li>✅ Valid for 7 days</li>
                          <li>✅ 24/7 realtime chat</li>
                        </ul>
                        <button 
                          onClick={() => handlePlanPurchase('Weekly', '51', 1, 100)}
                          className="popup-button">
                          {loadingContinueChat ? <span className="spinner"></span> : 'Purchase Plan'}</button>
                      </div>

                      <div class="plan-card">
                        <h2 class="plan-title">Monthly Plan</h2>
                        <p class="price">₹101 <span class="only">only</span></p>
                        <ul class="feature-list">
                          <li>✅ 999 free chats</li>
                          {/* <li>✅ Unlimited voice chats</li> */}
                          <li>✅ Valid for 30 days</li>
                          <li>✅ 24/7 realtime chat</li>
                        </ul>
                        <button 
                          onClick={() => handlePlanPurchase('Monthly', '101', 30, 999)}
                          className="popup-button">
                          {loadingContinueChat ? <span className="spinner"></span> : 'Purchase Plan'}</button>
                      </div>
                    </div>

                {/* <button 
                  onClick={() => handlePlanPurchase('Monthly', '101', 30, 9999)}
                  className="popup-button"
                > */}
                  {/* {loadingContinueChat ? <span className="spinner"></span> : 'Purchase Plan'}
                </button> */}
            
                {/* <CountdownToMidnight targetDate="2025-03-08T22:00:00"/> */}
                
              </div>
            ) : (
              <div>
                {/* <h2 className='popup-h2'>Or, get <strong className='highlighted-text'>10 daily</strong> chats</h2><h2> on Vedic Rashi app <strong className='highlighted-text'>for free.
                  <img style={{marginTop: '1.9rem'}} src='https://cdni.iconscout.com/illustration/premium/thumb/male-pandit-showing-mobile-illustration-download-in-svg-png-gif-file-formats--indian-holding-pack-people-illustrations-2319298.png' alt='pandit'></img>
                  <button onClick={handleInstall} className="popup-button"><i class="ri-download-line"></i> Install Now</button>
                </strong></h2> */}
                                  <h2>Get <strong className='highlighted-text'>unlimited monthly</strong> chats</h2><h2> for just <strong className='highlighted-text'>₹149 
                    <span className='strikethrough'> (₹499)</span>
                    <img src='https://cdni.iconscout.com/illustration/premium/thumb/pandit-ji-reading-mantras-illustration-download-in-svg-png-gif-file-formats--male-indian-mantra-slok-pack-people-illustrations-2319299.png?f=webp' alt='pandit'></img>
                <button 
                  onClick={() => handlePlanPurchase('Monthly', '149', 30, 9999)}
                  className="popup-button"
                >
                  {loadingContinueChat ? <span className="spinner"></span> : 'Purchase Plan'}
                </button>
                    </strong></h2>
              </div>
            
            )}
        
            <p className="subscription-link">
              Facing issues? Contact us at <Link className="pricing-link">vedicrashiofficial@gmail.com</Link>
            </p>
          </div>
        </div>        
        )}
{/* 
        {isVoiceCallOpen && (
          <div className="voice-call-popup-backdrop">
            <div className="voice-call-popup">
              <VoiceCallInterface
                getResponse={handleSend}
                language={language}
              />
              <button className="close-popup" onClick={() => setIsVoiceCallOpen(false)}>❌</button>
            </div>
          </div>
        )} */}
        
        {/* Chat UI */}
        <div>
          <Feedback
            userId={user.uid}
            userName={user.name}
            email={user.email}
            show={showFeedbackPopup}
            onClose={() => setShowFeedbackPopup(false)}
          />
        </div>
        {showContactMessage && <ContactTakingPopup onClose={handleClosingContact} onSubmit={handleSubmitContact} />}
      </div>
    </div>
  );
};

export default ChatInterface;
